import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import React from "react";

interface Props {
    title: string;
    orderNumber: string;
    orderDate?: string;
    isVmiOrderDetailsPage?: boolean;
    isVmiOrder?: boolean;
}

const OrderDetailPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    orderNumber,
    orderDate,
    isVmiOrderDetailsPage,
    isVmiOrder,
}) => {
    const queryString = isVmiOrderDetailsPage
        ? `orderNumber=${orderNumber}&orderDate=${orderDate}`
        : isVmiOrder
          ? `orderNumber=${orderNumber}&orderDate=${orderDate}&isVmiOrder=true`
          : `orderNumber=${orderNumber}&orderDate=${orderDate}`;

    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: isVmiOrderDetailsPage ? "VmiOrderDetailsPage" : "OrderDetailsPage",
            overrideTitle: title,
            queryString,
        },
    });
};

export default OrderDetailPageTypeLink;
